<template>
  <div class="side-icons">
    <ul class="connect">
      <li>
        <ul class="list-items">
          <li v-if="globalConfig.isMarketplaceOnlyPackages || (leadFormMessage.isLeadFormEnabled && contactUsConfig.showSpeakToAnExpert)">
            <a href="#" class="circle" @click.prevent="openLeadForm">
              <i class="icon icon-submit-query"></i>
              <div class="black">Submit Query</div>
            </a>
          </li>
          <li v-if="contactUsConfig.showCustomerCareNumber">
            <a class="circle">
              <i class="icon icon-call"></i>
              <div class="black">Call us at {{tollfree}}</div>
            </a>
          </li>

        </ul>

      </li>

    </ul>

  </div>
</template>

<script>
/* global yt_adobe */
import addDigitalDataObject from '../common/tracking'

export default {
  props: ['tollfree', 'contactUsConfig', 'leadFormMessage'],
  data: function() {
    return {
      globalConfig: {}
    }
  },
  created: function() {
    this.globalConfig = window.globalConfig
  },
  methods: {
    openLeadForm: function() {
      // Adobe tracking On the Click of Submit Query submit_tracking#1
      if (typeof yt_adobe !== 'undefined' && typeof yt_adobe.track == 'function') {
        var obj = addDigitalDataObject()
        obj.customLinkName = 'Submit Query'
        yt_adobe.track('custom-link-click', obj)
      }

      this.$emit('openLeadForm')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/hanging-icons.vue